
const color = {
    white: '#FFF',
    blue: '#007bff',
    red: '#dc3545',
    orange: '#fd7e14',
    yellow: '#fadb67',
    green: '#28a745',
    teal: '#20c997',
    cyan: '#17a2b8',
    gray: '#6c757d',
    graydark: '#343a40',
    primary: '#007bff',
    secondary: '#6c757d',
    success: '#28a745',
    info: '#17a2b8',
    warning: '#ffc107',
    danger: '#dc3545',
    light: '#f8f9fa',
    dark: '#343a40',
    menucolor: '#4CC4CF',
    headerbgcolor: '#1A2732',
    menubgcolor: '#394b5a',
    dtheader:'#4c3a3a',
    uiprimary:'#1ba1a6',
    uisecondary:'#e9eef3',
}


export default color
